import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ThemeSwitcherComponent } from './theme-switcher.component';

@NgModule({
	imports: [CommonModule, FormsModule],
	declarations: [ThemeSwitcherComponent],
	exports: [ThemeSwitcherComponent],
})
export class ThemeSwitcherModule {}
